import style from './ChatNotification.module.css';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { RxCross1 } from 'react-icons/rx';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUserType } from '../../../redux/auth/selectors';
import { selectIsMuted } from '../../../redux/settings/selectors';

const ChatNotification = ({ letter, id, user }) => {
  const navigate = useNavigate();
  const userType = useSelector(selectUserType);
  const isMutedNotification = useSelector(selectIsMuted);
  const userAvatar = user?.videoAvatar || user?.avatar;
  const hasVideo = userAvatar?.includes('videos');

  const handleCloseClick = () => {
    toast.dismiss(id);
  };

  const handleLetterClick = () => {
    if (letter?.senderType === 'support') {
      const object = {
        paidUser: 'man-user',
        agencyUser: 'agency-user',
      };
      navigate(`/${object[userType]}/customer-support`);
    } else if (letter?.senderType.includes('Support')) {
      const object = {
        paidUserSupport: 'paidUserSupport',
        agencyUserSupport: 'agencySupport',
      };
      navigate(
        `/agency-user/customer-support?type=${object[letter.senderType]}`,
      );
    } else if (userType === 'paidUser') {
      navigate(`/man-user/live-chat?chatId=${letter.chatId}`);
    } else if (userType === 'freeUser') {
      navigate(`/free-user/live-chat?chatId=${letter.chatId}`);
    }
    handleCloseClick();
  };

  useEffect(() => {
    if (isMutedNotification) {
      handleCloseClick();
    }
  }, [isMutedNotification]);

  if (isMutedNotification) {
    return null;
  }

  return (
    <div className={style.notification}>
      <div className={style.imgContainer}>
        {!hasVideo ? (
          <img
            loading="lazy"
            decoding="async"
            src={user?.avatar}
            alt={`${user?.name}_from_${user?.country}_${user?.city}`}
          />
        ) : (
          <video
            src={user?.videoAvatar}
            autoPlay
            loop
            muted
            playsInline
            controls={false}
            poster={user?.avatar}
          />
        )}
      </div>
      <div className={style.recipientContainer} onClick={handleLetterClick}>
        <h4>New message from {user?.name}</h4>

        {!letter.publicFiles.length && (
          <div
            dangerouslySetInnerHTML={{ __html: letter.text }}
            className={style.preview}
          ></div>
        )}
        {!!letter.publicFiles.length && (
          <div className={style.media}>
            <img
              loading="lazy"
              decoding="async"
              src={letter.publicFiles[0]}
              alt="user"
            />
          </div>
        )}
      </div>
      <div className={style.close} onClick={handleCloseClick}>
        <RxCross1 />
      </div>
    </div>
  );
};

export default ChatNotification;
